<template>
  <div>
    <div class="row mb-1">
      <div class="col-sm-6">
        <h4 class="text-uppercase mt-1">
          {{lexicon.drop_renains_and_photos}}
        </h4>
      </div>
      <div class="col-sm-6 text-right full-btn">

        <a  :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/html/'" target="_blank" class="btn btn-success mr-3 mb-2  ">
          <i class="feather icon-eye"></i>
          {{lexicon.drop_watch_catalog}}
        </a>
        <button class="btn btn-primary mb-2 " @click="showSettings()">
          <i class="feather icon-settings"></i>
          {{lexicon.drop_settings}}
        </button>
      </div>
    </div>
    <section id="xport" class="my-1" v-if="settings">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-md-6">
              <label> &nbsp;
              </label>
              <div class="alert alert-dark mb-0">
                <small>
                  {{lexicon.drop_settings_info}}
                </small>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>{{lexicon.drop_hide_products}}</label>
                    <input type="number" min="1" class="form-control" v-model="user.settings.min_stock"
                        @change="updateData('min_stock',$event.target.value)">
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label>{{lexicon.drop_lang_stock}}</label>
                    <select class="form-control" @change="updateData('files_lang',$event.target.value)"
                        v-model="user.settings.files_lang">
                      <option value="ua">{{lexicon.drop_lang_ua}}</option>
                      <option value="ru">{{lexicon.drop_lang_ru}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card-deck text-center">

            <div class="card mb-4 box-shadow">
              <div class="card-header">
                <h2 class="my-0 font-weight-normal mx-auto ">JSON</h2>
              </div>
              <div class="card-body">
                <ul class="list-unstyled mt-3 mb-4">
                  <li>{{lexicon.drop_title_data_format}} JSON</li>
                  <li>{{lexicon.drop_rem_title}}</li>
                  <li>
                    {{lexicon.drop_change_in_settings}}
                    <router-link :to="{'name':'settings'}">
                     {{lexicon.drop_in_settings}}
                    </router-link>
                  </li>
                  <li class="text-success">{{lexicon.drop_always_actual}}</li>
                </ul>
                <a class="btn   btn-block btn-primary"
                    :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/json/'"
                    target="_blank">{{lexicon.drop_go_to}}
                </a>
                <div class="mt-2 ">
                  {{lexicon.drop_data_link}}
                  <pre class="rounded text-left p-1 ws-nw ">
                    <button class="btn btn-dropbox btn-sm text-uppercase btn-block"
                        @click="e => e.target.classList.toggle('active-link')"> {{lexicon.drop_show_link}}</button>
                    <span class="rem_link">
                      https://api.brushme.com.ua/{{ user.api_token }}/public/products/json/
                    </span>
                  </pre>
                </div>
              </div>
            </div>
            <div class="card mb-4 box-shadow">
              <div class="card-header">
                <h2 class="my-0 font-weight-normal mx-auto ">XML</h2>
              </div>
              <div class="card-body">
                <ul class="list-unstyled mt-3 mb-4">
                  <li>{{lexicon.drop_title_data_format}} XML</li>
                  <li>{{lexicon.drop_rem_title}}</li>
                  <li>
                    {{lexicon.drop_change_in_settings}}
                    <router-link :to="{'name':'settings'}">
                     {{lexicon.drop_in_settings}}
                    </router-link>
                  </li>
                  <li class="text-success">{{lexicon.drop_always_actual}}</li>
                </ul>

                <a class="btn   btn-block btn-primary "
                    :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/xml/'"
                    target="_blank">{{lexicon.drop_go_to}}
                </a>
                <a class="btn   btn-block btn-info "
                    :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/fxml/'"
                    target="_blank">{{lexicon.drop_prom_variant}}
                </a>
                <div class="d-flex    "></div>
                <div class="mt-2  ws-nw">
                  <span class="text-success d-block" @click.exact="e => e.target.classList.toggle('active-link')"> <i
                      class="feather icon-info "></i> {{lexicon.drop_whats_diff}}</span>
                  <span class="rem_link">
                          <div class="alert alert-black">
                            {{lexicon.drop_prom_info}}
                            <div class="text-danger"> {{lexicon.drop_prom_warn}}</div>
                          </div>
                     </span>
                </div>
                <div class="mt-2 ">
                  {{lexicon.drop_data_link}}
                  <pre class="rounded text-left p-1 ws-nw ">
                    <button class="btn btn-dropbox btn-sm text-uppercase btn-block"
                        @click="e => e.target.classList.toggle('active-link')"> {{lexicon.drop_show_link}}</button>
                    <span class="rem_link">
                      https://api.brushme.com.ua/{{ user.api_token }}/public/products/xml/
                    </span>
                  </pre>
                  {{lexicon.drop_data_link_prom}}
                  <pre class="rounded text-left p-1 ws-nw ">
                    <button class="btn btn-info btn-sm text-uppercase btn-block"
                        @click="e => e.target.classList.toggle('active-link')"> {{lexicon.drop_show_link_prom}}</button>
                    <span class="rem_link">
                      https://api.brushme.com.ua/{{ user.api_token }}/public/products/fxml/
                    </span>
                  </pre>
                </div>

              </div>
            </div>
            <div class="card mb-4 box-shadow">
              <div class="card-header">
                <h2 class="my-0 font-weight-normal mx-auto ">CSV</h2>
              </div>
              <div class="card-body">
                <ul class="list-unstyled mt-3 mb-4">
                  <li>{{lexicon.drop_title_data_format}} CSV</li>
                  <li>{{lexicon.drop_rem_title}}</li>
                  <li>
                    {{lexicon.drop_change_in_settings}}
                    <router-link :to="{'name':'settings'}">
                     {{lexicon.drop_in_settings}}
                    </router-link>
                  </li>
                  <li class="text-success">{{lexicon.drop_always_actual}}</li>
                </ul>
                <a class="btn   btn-block btn-primary"
                    :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/csv/'"
                    target="_blank">{{lexicon.drop_go_to}}
                </a>
                <a class="btn   btn-block btn-info"
                    :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/csv/?semicolon'"
                    target="_blank">{{lexicon.drop_variant_semicolon}}
                </a>
                <div class="mt-2 ">
                  {{lexicon.drop_data_link}}
                  <pre class="rounded text-left p-1 ws-nw ">
                    <button class="btn btn-dropbox btn-sm text-uppercase btn-block"
                        @click="e => e.target.classList.toggle('active-link')"> {{lexicon.drop_show_link}}</button>
                    <span class="rem_link">
                      https://api.brushme.com.ua/{{ user.api_token }}/public/products/csv/
                    </span>
                  </pre>
                 {{lexicon.drop_dat_semicolon}}
                  <pre class="rounded text-left p-1 ws-nw ">
                    <button class="btn btn-info btn-sm text-uppercase btn-block"
                        @click="e => e.target.classList.toggle('active-link')">{{lexicon.drop_show_link_semicolon}}</button>
                    <span class="rem_link">
                      https://api.brushme.com.ua/{{ user.api_token }}/public/products/csv/?semicolon
                    </span>
                  </pre>
                </div>

              </div>
            </div>
            <div class="card mb-4 box-shadow">
              <div class="card-header ">
                <h2 class="my-0 font-weight-normal mx-auto ">XLS</h2>
              </div>
              <div class="card-body">
                <ul class="list-unstyled mt-3 mb-4">
                  <li>{{lexicon.drop_title_data_format}} XLS</li>
                  <li>{{lexicon.drop_monent_actual}}</li>
                  <li>
                    {{lexicon.drop_change_in_settings}}
                    <router-link :to="{'name':'settings'}">
                     {{lexicon.drop_in_settings}}
                    </router-link>
                  </li>
                  <li class="text-danger">{{lexicon.drop_fast_not_actual}}</li>
                </ul>
                <a class="btn   btn-block btn-outline-primary" target="_blank"
                    :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/xls/'"
                >
                  {{lexicon.drop_dln}}
                </a>
                <div class="mt-2 ">
                  {{lexicon.drop_data_link}}
                  <pre class="rounded text-left p-1 ws-nw ">
                    <button class="btn btn-dropbox btn-sm text-uppercase btn-block"
                        @click="e => e.target.classList.toggle('active-link')"> {{lexicon.drop_show_link}}</button>
                    <span class="rem_link">
                      https://api.brushme.com.ua/{{ user.api_token }}/public/products/xls/
                    </span>
                  </pre>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <div class="row mb-1">
      <div class="col-md-12">
        <h4 class="text-uppercase mt-1">{{lexicon.drop_products_images}}</h4>
      </div>
    </div>

    <section>
      <div class="row">
        <div class="col-12">
          <div class="card-deck ">
            <div class="card mb-2 box-shadow">
              <div class="card-header ">
                <h4 class="my-0 font-weight-normal ">{{lexicon.drop_images_warn_1}}</h4>
              </div>
              <div class="card-body">

                <p>{{lexicon.drop_images_warn_2}}</p>
                <p class="text-primary text-bold-700">{{lexicon.drop_images_warn_3}}</p>

                <hr>
                <form action="">
                  <div class="row">
                    <div class="col-12 col-md-2">
                      <label> &nbsp;</label>
                      <br>
                      <a class="btn    btn-success btn-block  he37"
                          :href="'https://api.brushme.com.ua/'+user.api_token+'/public/products/images/?&period='+start_date"
                          target="_blank">
                        {{lexicon.drop_wd_photo}}
                      </a>
                    </div>
                    <div class="col-12 col-md-2">
                      <div class="form-group mb-1">
                        <label>{{lexicon.drop_date_stock}}</label>
                        <select v-model="period" class="form-control d-inline">
                          <option value="all">{{lexicon.drop_all_stock}}</option>
                          <option value="custom">{{lexicon.drop_select_date}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-md-2" v-if="period==='custom'">
                      <div class="form-group mb-1">
                        <label>{{lexicon.drop_choose_date}}</label>
                        <date-range-picker v-model="start_date" format="YYYY-MM-DD" :options="date.options"
                            class="form-control w-auto float-right " id="dash-picker"/>
                      </div>
                    </div>
                  </div>

                </form>

              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mb-2">
          <div class="alert alert-warning text-center">
            {{lexicon.drop_supprot_info}}
            <a :href="'mailto:it@brushme.com.ua?subject='+user.phone" target="_blank">it@brushme.com.ua</a>
            . {{lexicon.drop_supprot_info_1}}
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

import axios from "axios";
import {mapGetters, mapState} from 'vuex'
import store from "@/store";
// import toast from "../helpers/toast";

export default {
  name: 'Remains',
  computed: {
    ...mapGetters({
      user: 'auth/user',
      authenticated: 'auth/authenticated',
    }),
    ...mapState({
      lexicon: 'lexicon',
    })
  },
  watch: {
    'period': function () {
      if(this.period === 'all'){
        this.start_date = '2018-01-01'
      } else {
        this.start_date = this.date.period
      }
    },
    'date.period': function () {
       this.start_date = this.date.period
    },
  },
  data() {
    return {
      period: 'all',
      start_date:'2018-01-01',
      date: {
        period: window.moment().add(-7, 'day').format('YYYY-MM-DD'),
        options: {
          startDate: window.moment().add(-7, 'day'),
          endDate: window.moment(),
          minYear: 2018,
          maxDate: window.moment().add(0, 'day'),
          maxYear: +window.moment().format("YYYY"),
          // locale: {
          //   format: 'DD.MM.YYYY'
          // },
          autoApply: true,
          singleDatePicker: true,
          showDropdowns: true,
        }
      },
      loading: true,
      settings: false,
      check_password: '',
      test: {},
      errors: {},
    }
  },
  created() {
    store.dispatch('auth/attempt', localStorage.getItem('token'))
  },
  methods: {
    showSettings() {
      this.settings = !this.settings
    },
    fetchData(data) {
      this.loading = true
      this.test = data
      axios.post('settings/', data).then((response) => {
        if (response.data.data.api_token) {
          this.user.api_token = response.data.data.api_token
        }
        this.loading = false
      })
    },
    // updateAuth() {
    //   this.errors = {}
    //   if (this.user.settings.password_type != 3) {
    //     this.fetchData({'param': 'auth', 'value': this.user.settings.password_type})
    //   } else {
    //     if (this.password !== this.check_password) {
    //       this.errors.password = 1
    //       this.errors.check_password = 1
    //       toast.error('Пароли не совпадают', 'Ошибка')
    //     } else {
    //       if (this.password.length > 3) {
    //         this.fetchData({
    //           'param': 'auth',
    //           'value': this.user.settings.password_type,
    //           'password': this.password
    //         })
    //       } else {
    //         this.errors.password = 1
    //         this.errors.check_password = 1
    //         toast.error('Минимальная длина пароля 6 символов', 'Ошибка')
    //       }
    //     }
    //   }
    // },
    // newToken() {
    //   this.fetchData({'param': 'token'})
    // },
    updateData(key, val) {
      if (val !== '') {
        this.fetchData({'param': key, 'value': val})
      }
    }
  }
}
</script>

<style>
.ws-nw {
  white-space: normal;
  cursor: pointer;
}

.ws-nw span, .ws-nw .active-link {
  display: none;
}

.ws-nw .active-link + span {
  display: block;
}

.ws-nw i.feather {
  pointer-events: none;
}

.he37 {
  height: 37px;
}

#dash-picker {
  /*border-top-left-radius: 0;*/
  /*border-bottom-left-radius: 0;*/
  width: 100% !important;
}
</style>